import dayjs from 'src/libs/dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
export const SCHEDULE_TIMEZONE = 'Asia/Singapore';

export const dateInput = (value?: string | null) =>
  value && dayjs(value).isValid()
    ? dayjs(value).tz(SCHEDULE_TIMEZONE).format('YYYY-MM-DDTHH:mm')
    : '';

// datetime-local values are Singapore wall times, regardless of browser settings.
export const isoDate = (value: string) =>
  dayjs.tz(value, SCHEDULE_TIMEZONE).toISOString();

type ScheduledTopic = {
  id?: string;
  start_at?: string | null;
  end_at?: string | null;
  sequence?: number;
};
const startTime = (topic: ScheduledTopic) => {
  const value = topic.start_at ? Date.parse(topic.start_at) : NaN;
  return Number.isFinite(value) ? value : Infinity;
};
export const sortTopics = <T extends ScheduledTopic>(topics: T[] = []): T[] =>
  [...topics].sort(
    (a, b) =>
      startTime(a) - startTime(b) ||
      (a.sequence || 0) - (b.sequence || 0) ||
      (a.id || '').localeCompare(b.id || ''),
  );

export const formatTopicSchedule = (topic: ScheduledTopic) => {
  if (!topic.start_at || !dayjs(topic.start_at).isValid()) return '';
  const format = (value: string) =>
    dayjs(value).tz(SCHEDULE_TIMEZONE).format('D MMM YYYY, HH:mm');
  const end =
    topic.end_at && dayjs(topic.end_at).isValid()
      ? ` – ${format(topic.end_at)}`
      : '';
  return `${format(topic.start_at)}${end} (${SCHEDULE_TIMEZONE})`;
};
